export default __webpack_public_path__ + "static/media/mahin-arafath.6dfb41ce.png";